export default __webpack_public_path__ + "static/1567-01618635ccbdf31f5d52035eac1b8e69.gif";